import delay from '@/utils/delay'
import { AppI18n } from '@/libs/i18n'
import dynamicRender from '@/utils/dynamicRender'
import getAppUISizeFromEnvs from '@/utils/getAppUISizeFromEnvs'
import isTopWindow from '@/utils/isTopWindow'

const currentVersion = __APP_VERSION__

const checkService = () => {
  return fetch(`/version.json?t=${Date.now()}`)
    .then((res) => res.json())
    .catch(console.error)
}

const versionCheckService = () => {
  if (import.meta.env.DEV) {
    return
  }

  if (!isTopWindow()) {
    return
  }

  checkService().then((result) => {
    if (result && result.version !== currentVersion) {
      dynamicRender.modalConfirm({
        size: getAppUISizeFromEnvs(),
        onSave: () => location.reload(),
        title: AppI18n.global.t('versionUpdate.title'),
        message: AppI18n.global.t('versionUpdate.msg'),
        modalProps: {
          confirmProps: { label: AppI18n.global.t('confirm'), icon: 'pi pi-sparkles' },
        },
      })

      return
    }

    delay(1000 * 60).then(versionCheckService)
  })
}

export default versionCheckService
